import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { IS_MOBILE, IS_WECHAT } from "@/utils/tool";
import Header from "@/components/Header/Header";

import "./index.scss";
import { useLocation } from "react-router";
import { OrderDetail } from "@/api/order";
import PcInfo from "./PcInfo";
import { useRecoilState, useResetRecoilState, useSetRecoilState } from "recoil";
import {
  OrderStore,
  mergeOrderSelectIdsStore,
  buyJournalStore,
} from "@/store/order";
import Footer from "@/components/Footer";
import OrderInvalid from "./OrderInvalid";
import useWrapEnv from "@/hooks/useWrapEnv";
import WechatGuide from "@/components/WechatGuide";

import MobileInfo from "./MobileInfo";
const Pay = () => {
  const { t } = useTranslation();
  const [step, setStep] = useState<number>();
  const location = useLocation();
  //   useWrapEnv();
  const queryParams = new URLSearchParams(location.search);
  const [orderInfo, setOrderInfo] = useRecoilState(OrderStore);
  const [orderInvalid, setOrderInvalid] = useState(false);
  const [showWechatGuide, setShowWechatGuide] = useState(false);
  const setBuyJournalStore = useSetRecoilState(buyJournalStore);
  const restMergeOrderSelectIdsStore = useResetRecoilState(
    mergeOrderSelectIdsStore,
  );
  const progressList = useMemo(() => {
    return [t("订单信息"), t("费用明细")];
  }, [t]);
  /**
   * 获取订单信息
   */
  const getDetail = async () => {
    const orderId = queryParams.get("order-id");
    const sign = queryParams.get("sign");
    const res = await OrderDetail<Order>({
      order_id: orderId,
      sign,
    });
    if (res.code === 0) {
      const data = res.data;
      setOrderInfo(data);
      // 各版本含税单价（key 为版本类型）
      const prices = (data.pod_versions || []).reduce<Record<number, number>>(
        (acc, version) => {
          acc[version.type] = version.price;
          return acc;
        },
        {},
      );
      // 当前订单生成了pod，代表可以勾选
      const podOrders = (data.pod_orders || []).filter(
        (item) => item.order_id,
      );
      if (podOrders.length > 0) {
        const numbers = podOrders.reduce<Record<number, number>>(
          (acc, item) => {
            acc[item.type] = item.number;
            return acc;
          },
          {},
        );
        setBuyJournalStore({
          numbers,
          prices,
          checked: true,
          receive: podOrders[0].receive,
        });
      } else {
        setBuyJournalStore((prev) => ({ ...prev, prices }));
      }
    } else {
      if (res.code === 100001) {
        setOrderInvalid(true);
      }
    }
  };

  // 关闭微信引导
  const handleCloseWechatGuide = () => {
    setShowWechatGuide(false);
  };

  useEffect(() => {
    if (IS_MOBILE) {
      setStep(0);
    }
  }, []);

  useEffect(() => {
    // 检测是否是微信浏览器
    if (IS_WECHAT) {
      setShowWechatGuide(true);
    }
  }, []);

  useEffect(() => {
    getDetail();
    return () => {
      restMergeOrderSelectIdsStore();
    };
  }, []);

  useEffect(() => {
    const orderId = queryParams.get("order-id");
    const sign = queryParams.get("sign");
    localStorage.setItem("orderId", orderId);
    localStorage.setItem("sign", sign);
  }, []);

  return (
    <div className="pay-box">
      <Header title={progressList[step]} step={step} setStep={setStep} />
      {!orderInvalid ? (
        <>
          {IS_MOBILE ? (
            <div className="pay-content">
              {orderInfo && (
                <MobileInfo order={orderInfo} setStep={setStep} step={step} />
              )}
            </div>
          ) : (
            <div className="pay-content">
              {orderInfo && <PcInfo order={orderInfo} />}
            </div>
          )}
        </>
      ) : (
        <OrderInvalid />
      )}
      {!IS_MOBILE && <Footer></Footer>}
      {/* 微信浏览器引导提示 */}
      <WechatGuide visible={showWechatGuide} onClose={handleCloseWechatGuide} />
    </div>
  );
};
export default Pay;
